import Furniture from './Furniture';

export default class ButterflyCycle extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.state = data.state || 1;
    this.setAnim(this.state, this.state === 2);
    this.canTap = this.state === 2;

    this.asset.onComplete.add(this.handleAnimComplete, this);

    this.setButton();
  }

  handleInputDown() {
    if (this.canTap) {
      this.canTap = false;
      this.nextState();
      this.setButton();
    }
  }

  handleAnimComplete() {
    switch (this.state) {
      case 1:
        this.nextState();
        this.setButton();
        this.canTap = true;
        break;
      case 3:
        this.setButton();
        this.canTap = true;
        break;
      case 4:
      case 5:
        this.nextState();
    }
  }

  nextState() {
    this.canTap = false;
    this.state = this.state < 5 ? this.state + 1 : 1;
    this.setAnim(this.state, this.state === 2);

    if (this.state === 5) {
      this.location.state.setLoopHint(this.data.hint);
    }

    //
    this.onChange.dispatch();
  }

  setButton() {
    if (this.state === 1 || this.state === 2) {
      this.button.x = -150;
      this.button.y = -150;
      this.button.visible = true;
    } else if (this.state === 3) {
      this.button.x = -150;
      this.button.y = -50;
      this.button.visible = true;
    } else {
      this.button.visible = false;
    }
  }

  updateBounds() {
    this.bb = this.getBounds();
    this.bb.width = 50;
    this.bb.height = 70;
  }

  //
  serialize() {
    const data = super.serialize();
    data.state = this.state;
    return data;
  }
}
